import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import profile from "../images/profile.svg";
import { TiPencil } from "react-icons/ti";
import { FaPlus } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { setPatientDetails, setAppointmentList } from "../reduxtool/action";
import EditProfile from "./EditProfile";
import { Link, useNavigate } from "react-router-dom";
import { dividerClasses } from "@mui/material";
// import '../ScrollBar/ScrollBar.css'
import check from "../images/check.png";
import AppointmentDetailModal from "../Appointments/AppointmentDetailModal";
import { decryptData } from "../Services/TabServices";
import { PDFDownloadLink, PDFViewer } from "@react-pdf/renderer";
import AppointmentPaymentReceipt from "../Appointments/AppointmentPaymentReciept";
import ReceiptModal from "../Appointments/ReceiptModal";

const PatientProfile = () => {
  const navigate = useNavigate();
  const dispatch: any = useDispatch();
  const patientProfile = useSelector((state: any) => state.userDetails);
  const AppointmentList = useSelector(
    (state: any) => state.patientAppointmentList
  );
  const [selectedReceipt, setSelectedReceipt] = useState<any | null>(null);
  
  const [isMedicalDone, setIsMedicalDone] = useState(false);
  const token = sessionStorage.getItem("token");
 
  const storedUserId = sessionStorage.getItem("userId");
const PatientId = storedUserId ? decryptData(storedUserId) : null;
  const [age, setAge] = useState<string>(" ");
  const [bloodGroup, setBloodGroup] = useState<any>([]);
  const [profileImage, setProfileImage] = useState<string>("");
  const [activeSection, setActiveSection] = useState<string>("Appointment");
  const [healthError, setHealthError] = useState<string>("");
  const [activeSectionSecond, setActiveSectionSecond] =
    useState<string>("Upcomming");
    const [statusFilter, setStatusFilter] = useState<string>("All");
const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [isPopUpOpen, setPopUpOpen] = useState(false);
  const [healthData, setHealthData] = useState({
    GroupId: "",
    chronicCondition: "",
    allergies: "",
    bloodGroup: "",
    PatientId: PatientId,
  });
  const [selectedAppointment, setSelectedAppointment] = useState<any | null>(
    null
  );
 const calculateAge = (dobString: string): string => {
  if (!dobString) return "";
  const dob = new Date(dobString);
  const today = new Date();

  let years = today.getFullYear() - dob.getFullYear();
  let months = today.getMonth() - dob.getMonth();
  let days = today.getDate() - dob.getDate();

  if (days < 0) {
    months -= 1;
    const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
    days += prevMonth.getDate();
  }

  if (months < 0) {
    years -= 1;
    months += 12;
  }

  // Always show years, months, and days
  return `${years} year${years !== 1 ? 's' : ''} ${months} month${months !== 1 ? 's' : ''} ${days} day${days !== 1 ? 's' : ''}`;
};


  useEffect(() => {
    if (!PatientProfile) {
      dispatch(setPatientDetails(token, PatientId));
    }
      window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [dispatch, token, PatientId, PatientProfile]);

  // useEffect(() => {
  //     dispatch(setAppointmentList());
  // }, [dispatch]);
 const filteredUpcomingAppointments = AppointmentList?.upcomingAppointments?.filter((appointment: any) =>
    statusFilter === "All" ? true : appointment.flag === statusFilter
  );

  const filteredPastAppointments = AppointmentList?.pastAppointments?.filter((appointment: any) => {
    const slotEndTime = new Date(`${appointment.appointmentDate}T${appointment.slotEndTime}`);
    const now = new Date();

    let displayFlag = appointment.flag;
    if ((appointment.flag === "A" || appointment.flag === "S") && slotEndTime < now) {
      displayFlag = "M";
    }

    return statusFilter === "All" ? true : displayFlag === statusFilter;
  });
  useEffect(() => {
    const isAppointmentsEmpty =
      !AppointmentList || Object.keys(AppointmentList).length === 0;

    if (isAppointmentsEmpty) {
      dispatch(setAppointmentList());
    }
  }, [dispatch, AppointmentList]);

  useEffect(() => {
    if (patientProfile?.dob) {
      setAge(calculateAge(patientProfile.dob));
    }
    if (patientProfile?.patientImages?.length > 0) {
      setProfileImage(patientProfile.patientImages[0]?.imagePath);
    }
  }, [patientProfile]);
 const fetchBloodGroup = async () => {
    try {
      const response: any = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/GetBloodGroup`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setBloodGroup(response.data);
    } catch (error: any) {
      console.error("Error in getting Blood Group", error);
      const errorMsg = error.response && error.response.status;
      if (errorMsg === 401){
        navigate("/login");
      }
    }
  };
  useEffect(() => {
    const fetchProfileMedicalInformation = async () => {
      try {
        const response: any = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/Patient/GetDoctorforpatientprofiledetails?patientId=${PatientId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const patientBloodGroup = response.data.bloodGroup; // e.g., "A-"
       const bloodGroupId=response.data.bloodGroupId;

        setHealthData((prevData) => ({
          ...prevData,
          allergies: response.data.allergies || "",
          chronicCondition: response.data.chronicCondition || "",
          bloodGroup: patientBloodGroup || "",
          GroupId: bloodGroupId || "",
        }));
      } catch (error: any) {
        console.error("error in Getting medical information ", error);
        const errorMsg = error.response && error.response.status;
        if (errorMsg === 401) {
          navigate("/login");
        }
      }
    };
    fetchProfileMedicalInformation();
  }, []);

  useEffect(() => {
    if (bloodGroup.length === 0) {
      fetchBloodGroup();
    }
  }, [bloodGroup]);

  const handleEditProfile = () => {
    setPopUpOpen(true);
  };
 
  const handleChangeHealth = (e: any) => {
    const { name, value } = e.target;
    setHealthData((prev: any) => ({ ...prev, [name]: value }));
  };

  const handleSubmitHealthDetails = async () => {
    if (!healthData.GroupId) {
      setHealthError("Blood Group is required");
      return;
    }
    setHealthError("");
    if (!healthData.chronicCondition && !healthData.allergies){
      return;
    }
    try {
      setIsMedicalDone(false);
      const response: any = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/Patient/AddHealthDetails`,
        healthData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setIsMedicalDone(true);
       setShowSuccessPopup(true);
    } 
    catch (error: any) {
      console.error("Error in Submit Health Details", error);
    }
  };
const handleReceipt=(appointment:any)=>{
setSelectedReceipt(appointment);
}  
  const handlePatientPrescription = (appointment: any) => {
    setSelectedAppointment(appointment);
  };
 const getAge = (dob: string) => {
    if (!dob) return "N/A";
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age.toString();
  };

  const patientInfo = {
    name: patientProfile?.patientName || "N/A",
    gender:
      patientProfile?.gender === "M"
        ? "Male"
        : patientProfile?.gender === "F"
        ? "Female"
        : "Other",
    age: age  ,
 
  };
return (
    <div className="flex justify-center w-full">
      {selectedAppointment && (
        <AppointmentDetailModal
          appointment={{
            appointmentId: selectedAppointment.appointmentId,
            name: selectedAppointment.patientName || "N/A",
            specialty: selectedAppointment.specializationName,
            date: selectedAppointment.formatedDate,
            time: selectedAppointment.formatedTime,
            doctorName: selectedAppointment.doctorName,
            doctorFees: selectedAppointment.doctorFees,
              openAppointmentTab:activeSectionSecond,
               flag:selectedAppointment.flag,
            remarks: selectedAppointment.remarks || "No remarks available",
          }}
          onClose={() => setSelectedAppointment(null)}
        />
      )}
      <div className="mx-2 sm:mx-3 md:mx-2 lg:mx-5 w-[99%] xs:w-[97%] lg:w-[90%] xl:w-[90%]">
        <div className="mb-5">
          <span className="text-black text-lg sm:text-xl md:text-2xl font-medium p-2">
            User Profile
          </span>
        </div>
{showSuccessPopup && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-6 rounded-lg shadow-lg w-[90%] sm:w-[400px] text-center">
      <img src={check} alt="Success" className="w-8 h-8 mx-auto mb-4" />
      <p className="text-lg font-semibold">Success!</p>
      <p className="text-sm mt-2">
        Patient health details have been updated successfully.
      </p>
      <button
        className="mt-4 bg-[#009A85] text-white px-4 py-2 rounded hover:bg-[#007f6d]"
        onClick={() => setShowSuccessPopup(false)}
      >
        OK
      </button>
    </div>
  </div>
)}
  {selectedReceipt && (
        <ReceiptModal
          appointment={selectedReceipt}
          patientInfo={patientInfo}
          patientProfile={patientProfile}
          onClose={() => setSelectedReceipt(null)}
        />
      )}


        {/* profile section  */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-2 gap-5 sm:gap-10 mx-2 sm:mx-3 md:mx-10 lg:mx-20">
          {/* profile information  */}
          <div className=" border min-w-[320px] relative rounded-xl relative shadow-md shadow-gray-400">
            <div className="bg-[#009A85] text-center relative pt-5 pb-2 rounded-tl-xl rounded-tr-xl">
              <div className="flex justify-center ">
                <img
                  src={
                    patientProfile?.patientImages?.[0]?.imagePath
                      ? `${process.env.REACT_APP_BASE_URL}${patientProfile.patientImages[0].imagePath}`
                      : profile
                  }
                  alt="profile"
                  className="w-20 h-20 rounded-full bg-white"
                />
              </div>
              <h2 className="text-white text-[20px] font-semiboldddd ">
                {" "}
                {patientProfile?.patientName}
              </h2>
              <p className="text-white text-[12px]">{age}</p>
            </div>
            {/* Contact Details */}
            <div className=" border-b border-2 border-white ">
              <div className="flex items-center justify-center  gap-3  border-white border-b-4 py-1 text-[12px] bg-[#009A850D]">
                <IoCallOutline />
                <p className="text-[#009A85] font-medium">
                  {patientProfile.phoneNo}
                </p>
              </div>
              <div className="flex items-center justify-center  gap-3  text-[12px] bg-[#009A850D]">
                {patientProfile.email && (
                  <div className="flex items-center justify-center  gap-3 py-1 text-[12px] ">
                    <CiMail />
                    <p className="text-[#009A85]">{patientProfile.email}</p>
                  </div>
                )}
              </div>
            </div>
            <div className="px-6 py-3 flex justify-end">
              <button
                className="bg-[#009A85] text-white px-4 py-[6px] text-[12px] rounded-lg shadow-md hover:bg-[#006652] transition"
                onClick={handleEditProfile}
              >
                Edit Profile
              </button>
            </div>
            {isPopUpOpen && (
              <EditProfile
                age={age}
                onClose={() => setPopUpOpen(false)}
                profileImage={profileImage}
              />
            )}
          </div>

          {/* Medical information  */}
          <div className="  bg-[#F8F8F8] border gap-5  px-4  py-4 rounded-xl min-w-[320px] shadow-md shadow-gray-400">
            <div className="">
              <div className="flex justify-center ">
                <p className="text-[15px] font-semibold">
                  {" "}
                  Medical Information
                </p>
              </div>
              <div className="lg:px-5">
                <div className="flex text-[12px] gap-2 mt-10">
                  <p className="font-semibold">Blood Group</p>
                  <select
  value={healthData.bloodGroup} // <-- preselect the value
 onChange={(e) => {
      const selectedGroup = bloodGroup.find(
        (option: any) => option.groupName === e.target.value
      );
      setHealthData({
        ...healthData,
        bloodGroup: selectedGroup?.groupName || "",
        GroupId: selectedGroup?.groupId || "",
      });
    }}
>
  <option value="">Select</option>
  {bloodGroup.map((option: any, index: number) => (
    <option key={index} value={option.groupName}>
      {option.groupName}
    </option>
  ))}
</select>
                </div>

                <div className="flex gap-5 mt-5 w-full">
                  <div className="w-[50%]">
                    <p className=" text-[12px] font-semibold">
                      Chronic Condition
                    </p>
                    <textarea
                      name="chronicCondition"
                      rows={4}
                      value={healthData.chronicCondition}
                      onChange={handleChangeHealth}
                      className="w-full focus:outline-none focus:ring-1 focus:ring-[#009A85] text-[12px] mt-1 rounded-sm text-gray-500"
                    />
                  </div>
                  <div className="w-[50%]">
                    <p className=" text-[12px] font-semibold">Allergies</p>
                    <textarea
                      name="allergies"
                      rows={4}
                      value={healthData.allergies}
                      onChange={handleChangeHealth}
                      className="w-full focus:outline-none focus:ring-1 focus:ring-[#009A85] text-[12px] mt-1 rounded-sm text-gray-500"
                    />
                  </div>
                </div>
              </div>

              <div className="relative flex justify-end items-center gap-2 mt-3 mr-2 ">
                {healthError && (
                  <p className="absolute text-start text-red-500 text-[10px] left-1">
                    {healthError}
                  </p>
                )}
                <button
                className="bg-[#009A85] text-white px-4 py-[6px] text-[12px] rounded-lg shadow-md hover:bg-[#006652] transition"
                  onClick={handleSubmitHealthDetails}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* appointment and lab test and medicines */}
        <div className="bg-[#F8F8F8] mt-10 rounded-xl mb-5 pb-2 mx-1 sm:mx-3 md:mx-10 lg:mx-20">
          <div className="flex justify-center ">
            <div>
              <p className="flex justify-center font-semibold mt-3">
                Health Records
              </p>
              <p className="text-[12px] border-b  border-black py-2 px-3">
                View and manage your health records. Keeping your records
                updated can help ensure continuity of care.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-between mx-4 xs:mx-10 py-5">
            <div className="">
              <div>
                <div className="flex gap-2 xs:gap-5 mt-3">
                  <button
                    className={`px-2 sm:px-4 py-1 rounded-md  ${
                      activeSection === "Appointment"
                        ? "bg-[#009A85] text-white shadow-sm shadow-gray-400"
                        : "bg-[#B3B3B3] text-[#606060]"
                    }`}
                    onClick={() => {
                      setActiveSection("Appointment");
                      setActiveSectionSecond("Upcomming");
                    }}
                  >
                    Appointment
                  </button>
                  <button
                    className={`px-2 sm:px-4 py-1 rounded-md ${
                      activeSection === "Lab"
                        ? "bg-[#009A85] text-white"
                        : "bg-[#B3B3B3] text-[#606060]"
                    }`}
                    onClick={() => {
                      setActiveSection("Lab");
                      setActiveSectionSecond("");
                    }}
                  >
                    Lab Test
                  </button>
                  <button
                    className={`px-2 sm:px-4  py-1 rounded-md ${
                      activeSection === "Medicine"
                        ? "bg-[#009A85] text-white"
                        : "bg-[#B3B3B3] text-[#606060]"
                    }`}
                    onClick={() => setActiveSection("Medicine")}
                  >
                    Medicine
                  </button>
                </div>

                {/* second ilter  */}
                {activeSection === "Appointment" && (
                <div className="flex sm:flex-row  gap-5 mt-3">
  <div className="flex gap-5">
    <button
      className={`px-4 py-1 rounded-md text-[12px] ${
        activeSectionSecond === "Upcomming"
          ? "bg-[#009A85] text-white shadow-sm shadow-gray-400"
          : "bg-[#B3B3B3] text-white"
      }`}
      onClick={() => {
        setActiveSectionSecond("Upcomming");
        setStatusFilter("All");
      }}
    >
      Upcoming
    </button>
    <button
      className={`px-4 py-1 rounded-md text-[12px] ${
        activeSectionSecond === "Past"
          ? "bg-[#009A85] text-white shadow-sm shadow-gray-400"
          : "bg-[#B3B3B3] text-white"
      }`}
      onClick={() => {
        setActiveSectionSecond("Past");
        setStatusFilter("All");
      }}
    >
      Past
    </button>
  </div>

 <div className="relative inline-block">
  <select
    className="px-4 py-1 xs:py-1 pr-8 rounded-md text-[12px] text-[#009A85]  focus:outline-none focus:ring-0 border-none appearance-none shadow-sm shadow-gray-400"
    value={statusFilter}
    onChange={(e) => setStatusFilter(e.target.value)}
  >
    <option className="text-black" value="All">All Statuses</option>
    <option className="text-black" value="A">Confirmed</option>
    <option className="text-black" value="S">Scheduled</option>
    <option className="text-black" value="M">Missed</option>
    <option className="text-black" value="C">Cancelled</option>
    <option className="text-black" value="D">Completed</option>
    <option className="text-black" value="R">Rescheduled</option>
  </select>

  {/* Custom arrow icon */}
  <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center text-[#009A85] text-sm">
    ▾
  </div>
</div>

</div>

                )}
              </div>
            </div>
          </div>

          <div className=" lg:mx-20 xs:mx-5 ">
            <div
              className="overflow-y-auto custom-scrollbar"
              style={{ height: "calc(100vh - 300px)" }}
            >
              {activeSection === "Appointment" &&
                activeSectionSecond === "Upcomming" &&
                (filteredUpcomingAppointments?.length > 0 ? (
                 filteredUpcomingAppointments?.map(
                    (appointment: any) => (
                      <div
                        key={""}
                        className="grid grid-cols-3 gap-1 bg-[#009A850D]  xs:p-3  mx-2 p-3 xs:mx-4 mt-2 rounded-lg"
                      >
                        <div>
                                 <p className="font-semibold text-[12px] truncate">{appointment.doctorName}</p>

                          <p className="text-[#606060] text-[12px] mt-2">
                            {appointment.specializationName}
                          </p>
                        </div>
                        <div className="flex  justify-center">
                          <div className="flex flex-col text-start">
                            <p className="font-semibold text-[12px]">
                              {appointment.formatedDate},{" "}
                              {appointment.formatedTime}
                            </p>
                          
  <div className="flex flex-col gap-1 mt-2">
    
    <button
      className="bg-[#184A84] text-white px-2 py-1 text-[12px] rounded-lg"
      onClick={() => handleReceipt(appointment)}
    >
      View Invoice
    </button>
  </div>
                          </div>
                        </div>
                        <div className="flex  justify-end">
                          <div className="flex flex-col text-end">
                            <button
                               className={`p-1 px-2 text-[10px] rounded-lg border ${  appointment.flag === "S"
                                  ? "bg-[#00C85333] text-[#00C853] border border-[#00C853]":
    appointment.flag === "A" 
      ? "bg-[#E6F4EA] text-[#2E7D32] border-[#A5D6A7]"           // Confirmed
      : appointment.flag === "Pending"
      ? "bg-[#FFF8E1] text-[#F9A825] border-[#FFEE58]"           // Pending
      : appointment.flag === "M"
      ? "bg-[#FDECEA] text-[#D32F2F] border-[#EF9A9A]"           // Missed
      : appointment.flag === "R"
      ? "bg-[#E3F2FD] text-[#1565C0] border-[#90CAF9]"           // Rescheduled
      : appointment.flag === "D"
      ? "bg-[#E8F5E9] text-[#388E3C] border-[#A5D6A7]"           // Completed
      : appointment.flag === "C"
      ? "bg-[#FBE9E7] text-[#C62828] border-[#EF9A9A]"           // Cancelled
      : "bg-[#ECEFF1] text-[#546E7A] border-[#B0BEC5]"           // Unknown/fallback
  }`}
>
  {
  appointment.flag === "A"  
    ? "Confirmed"
    :appointment.flag === "S"
    ?"Scheduled"
    : appointment.flag === "M"
    ? "Missed"
    : appointment.flag === "R"
    ? "Rescheduled"
    : appointment.flag === "D"
    ? "Completed"
    : appointment.flag === "C"
    ? "Cancelled"
    : appointment.flag
    }
                            </button>

                            {/* <p className="text-[#606060] text-[14px]">
                              Charges: ₹{appointment.doctorFees}
                            </p> */}
                            <button
                              className="bg-[#009A85] text-white px-1 xs:px-2 py-1 text-[10px] rounded-lg mt-1"
                              onClick={() =>
                                handlePatientPrescription(appointment)
                              }
                            >
                              View Details
                            </button>
                          </div>
                        </div>
                      </div>
                    )
                  )
                ) : (
                  <div className="flex justify-center items-center h-[300px]">
                    <div className="text-center">
                      <p className="text-lg font-semibold">
                        No Appointments Yet!
                      </p>
                      <p className="text-sm mt-1 text-[#606060]">
                        View and manage your health records. Keeping your
                        records updated can help ensure continuity of care.
                      </p>
                      <Link to="/doctors">
                        {" "}
                        <button className="bg-[#009A85] text-white px-5 py-2 rounded-lg mt-4 hover:bg-[#007a68] transition-all  shadow-sm shadow-gray-400">
                          Book Appointment
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}
               
              {activeSection === "Appointment" &&
                activeSectionSecond === "Past" &&
                (filteredPastAppointments?.length > 0 ? (
                  filteredPastAppointments?.map((appointment: any, index: any) => {
 const slotEndTime = new Date(`${appointment.appointmentDate}T${appointment.slotEndTime}`);

  const now = new Date();  
  let displayFlag = appointment.flag;
      if ((appointment.flag === "S" || appointment.flag === "A") && slotEndTime < now) {
        displayFlag = "M";
      }
  return (
    <div
      key={index}
      className="grid grid-cols-3 gap-2  bg-[#D9D9D9] xs:p-3 mx-2 p-3 xs:mx-4 mt-2 rounded-lg"
    >
      <div>
        <p className="font-semibold text-[12px] truncate">{appointment.doctorName}</p>
        <p className="text-[#606060] text-[12px] mt-2">
          {appointment.specializationName}
        </p>
      </div>
      
      <div className="flex justify-start xs:ml-10">
        <div className="flex flex-col text-start">
          <p className="font-semibold text-[12px]">
            {appointment.formatedDate}, {appointment.formatedTime}
          </p>
          
  <div className="flex flex-col gap-1 mt-2">
    
    <button
      className="bg-[#184A84] text-white px-2 py-1 text-[12px] rounded-lg"
      onClick={() => handleReceipt(appointment)}
    >
       Invoice
    </button>
  </div>
        </div>
      </div>

      <div className="flex justify-end">
        <div className="flex flex-col text-end">
          <button
             className={`p-1 px-2 text-[10px] rounded-lg border ${
                  displayFlag === "S"
                    ? "bg-[#00C85333] text-[#00C853] border border-[#00C853]"
                    : displayFlag === "A"
                    ? "bg-[#E6F4EA] text-[#2E7D32] border-[#A5D6A7]"
                    : displayFlag === "Pending"
                    ? "bg-[#FFF8E1] text-[#F9A825] border-[#FFEE58]"
                    : displayFlag === "M"
                    ? "bg-[#FDECEA] text-[#D32F2F] border-[#EF9A9A]"
                    : displayFlag === "R"
                    ? "bg-[#E3F2FD] text-[#1565C0] border-[#90CAF9]"
                    : displayFlag === "D"
                    ? "bg-[#E8F5E9] text-[#388E3C] border-[#A5D6A7]"
                    : displayFlag === "C"
                    ? "bg-[#FBE9E7] text-[#C62828] border-[#EF9A9A]"
                    : "bg-[#ECEFF1] text-[#546E7A] border-[#B0BEC5]"
                }`}
              >
                {
                  displayFlag === "A"
                    ? "Confirmed"
                    : displayFlag === "S"
                    ? "Scheduled"
                    : displayFlag === "M"
                    ? "Missed"
                    : displayFlag === "R"
                    ? "Rescheduled"
                    : displayFlag === "D"
                    ? "Completed"
                    : displayFlag === "C"
                    ? "Cancelled"
                    : displayFlag
                }
          </button>
          {/* <p className="text-[#606060] text-[14px]">
            Charges: ₹{appointment.doctorFees}
          </p> */}
          <button
            className="bg-[#009A85] text-white px-1 xs:px-2 py-1 text-[10px] rounded-lg mt-1"
            onClick={() => handlePatientPrescription(appointment)}
          >
            View Details
          </button>
        </div>
      </div>
    </div>
  );
})
                ) : (
                  <div className="flex justify-center items-center h-[300px]">
                    <div className="text-center ">
                      <p className="text-lg font-semibold ">
                        No Appointments Yet!
                      </p>
                      <p className="text-sm mt-1 text-[#606060]">
                        View and manage your health records. Keeping your
                        records updated can help ensure continuity of care.
                      </p>
                      <Link to="/doctors">
                        {" "}
                        <button className="bg-[#009A85] text-white px-5 py-2 rounded-lg mt-4 hover:bg-[#007a68] transition-all  shadow-sm shadow-gray-400">
                          Book Appointment
                        </button>
                      </Link>
                    </div>
                  </div>
                ))}

              {activeSection === "Lab" && (
                <div className="flex justify-center items-center h-[300px]">
                  <div className="text-center">
                    <p className="text-xl font-semibold text-[#333]">
                      Lab Tests Coming Soon!
                    </p>
                    <p className="text-sm mt-2 text-[#606060]">
                      Skip the clinic queues! Very soon, you'll be able to book
                      lab tests straight from your home with just a few clicks.
                      Fast, easy, and fully reliable — we're making healthcare
                      more accessible for you. Stay tuned for the big launch! 🎉
                    </p>
                  </div>
                </div>
              )}

              {activeSection === "Medicine" && (
                <div className="flex justify-center items-center h-[300px]">
                  <div className="text-center">
                    <p className="text-xl font-semibold text-[#333]">
                      Online Medicine Orders Coming Soon!
                    </p>
                    <p className="text-sm mt-2 text-[#606060]">
                      Your health deserves the best!🧡We're putting together
                      customized health packages to suit your needs. Regular
                      check-ups, full body scans, and more — all in one place.
                      Exciting offers will be available soon. Watch this space!
                      🔥
                    </p>
                  </div>
                </div>
              )} 
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientProfile;
